import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';

export const AnimationTypingText = (props) => {

    const [index, updateIndex] = useState(0)
    const [text, updateText] = useState('')

    useEffect(() => { typingAnimation(index, text) }, [])

    const stringLength = props.text.length
    const totalAnimationTime = 750

    const calculateLinearTimeout = (index) => {
        return totalAnimationTime/stringLength
        // return 2 * totalAnimationTime *
        //     (stringLength - index) / (Math.pow(stringLength, 2)) +
        //     (100 * index / stringLength)
    }

    const typingAnimation = (index, text) => {
        updateText(text + props.text.charAt(index))
        updateIndex(index + 1)
        if (index < props.text.length) {
            const timeout = calculateLinearTimeout(index)
            setTimeout(() => {
                typingAnimation(index + 1, text + props.text.charAt(index))
            }, timeout)
        }
    }

    return (
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
            <Text style={{ fontSize: 16, textAlign: 'center' }}>
                {text}
            </Text>
        </View>
    );
}
